module.exports = __webpack_public_path__ + "img/vivo.c7c45704.png";